/**
 * Điều chỉnh TSCĐ
 * pdtai 13.07.2023
 */
export default {
    DieuChinh: 'Điều chỉnh TSCĐ ',
    HaoMonLonHonNguyenGia: 'Hao mòn lũy kế không thể lớn hơn nguyên giá.',
    HaoMonNamLonHonNguyenGia: 'Giá trị hao mòn năm không thể lớn hơn nguyên giá.',
    GiaTriConLaiLonHonNguyenGia: 'Giá trị còn lại không thể lớn hơn nguyên giá.',
    KhongChon: 'Không chọn',
    DuToan: 'Dự toán',
    NgayHTLonHonNgayCT: 'Ngày hạch toán phải lớn hơn ngày hạch toán Chứng từ điều chỉnh TSCĐ gần nhất',
    KhongTheDieuChinh: 'Tài sản cố định không thể điều chỉnh được có thể do những nguyên nhân sau: </br>- Chưa nhập số dư đầu hoặc</br>- Đã ghi giảm.',
    KhongTheChinhSua: 'Không thể chỉnh sửa',
    NgayHTKhongHopLe: 'Ngày HT phải nằm trong khoảng thời gian từ {0} đến {1}. Xin vui lòng kiểm tra lại',
    KhongHopLe: 'Không hợp lệ',
    NgayHTLonHonNgayKhoaSo: 'Ngày hạch toán phải lớn hơn ngày khóa sổ. Xin vui lòng kiểm tra lại.',
};